import { render, staticRenderFns } from "./diagonal-arrow-svg.vue?vue&type=template&id=573da769&scoped=true&"
var script = {}
import style0 from "./diagonal-arrow-svg.vue?vue&type=style&index=0&id=573da769&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573da769",
  null
  
)

export default component.exports